import { render, staticRenderFns } from "./InstagramGalleryAbout.vue?vue&type=template&id=1f48ba33&scoped=true"
import script from "./InstagramGalleryAbout.vue?vue&type=script&lang=js"
export * from "./InstagramGalleryAbout.vue?vue&type=script&lang=js"
import style0 from "./InstagramGalleryAbout.vue?vue&type=style&index=0&id=1f48ba33&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1f48ba33",
  null
  
)

export default component.exports